import { NpCategoryFeatureData } from "src/components/category/types"
import { NpFeatureIcon } from "src/components/np-design/components/NpFeatureIcon"
import { mapLineBreaksToHtmlBreaks } from "src/utilities/html"

export type NpCategoryFeaturesProps = {
  features: NpCategoryFeatureData[]
  maxDisplayed: 3 | 6
}

export const NpCategoryFeatures = ({ features, maxDisplayed }: NpCategoryFeaturesProps) => {
  return (
    <div className="grid max-w-full grid-cols-3 gap-6 gap-x-4 pt-2">
      {features.slice(0, maxDisplayed).map((feature, index) => {
        return (
          <div key={index} className="flex max-w-30 min-w-20 flex-1 flex-col items-center gap-4">
            <NpFeatureIcon name={feature.icon} />
            <div
              className="line-clamp-3 text-center text-sm"
              dangerouslySetInnerHTML={{ __html: mapLineBreaksToHtmlBreaks(feature.description) }}
            />
          </div>
        )
      })}
    </div>
  )
}
